function SidebarIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33333 4.66699L4 8.00033L7.33333 11.3337M11.3333 4.66699L8 8.00033L11.3333 11.3337"
        stroke="#454851"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SidebarIcon;
